export default __webpack_public_path__ + "static/media/betyakata-dashboard-logo.2726b9c3.png";